import { defineMessages } from 'react-intl';

export default defineMessages({
  requestChangesAction: {
    id: 'frontbucket.repository.pullRequest.requestChangesAction',
    description: 'Action to request changes for a pull request',
    defaultMessage: 'Request changes',
  },
  requestChangesUndoAction: {
    id: 'frontbucket.repository.pullRequest.requestChangesUndoAction',
    description: 'Action to undo the request changes state on a pull request',
    defaultMessage: 'Changes requested',
  },
  undoRequestChangesLabel: {
    id: 'frontbucket.repository.pullRequest.undoRequestChangesLabel',
    description: 'Label for request changes selected button',
    defaultMessage: 'Request changes on this pull request',
  },
  requestChangesLabel: {
    id: 'frontbucket.repository.pullRequest.requestChangesLabel',
    description: 'Label for request changes button',
    defaultMessage: 'Remove changes requested state from this pull request',
  },
  requestChangesActionInfo: {
    id: 'frontbucket.repository.pullRequest.requestChangesActionInfo',
    description: 'Information of the changesRequested action.',
    defaultMessage: 'You requested changes {date}',
  },
});
